<span (click)="openModal(keyword)" class="btn-header">ricarica</span>
